export default "__VITE_ASSET__03b4d6bd__"